module.exports = __webpack_public_path__ + "img/1536725742.4ddef073.jpg";